import { TranslationKey } from '@Localization';

export class FieldStatus {
  constructor(
    public isValid?: boolean | undefined,
    public errors: TranslationKey[] = []
  ) {}

  static empty(): FieldStatus {
    return new FieldStatus(undefined, []);
  }

  static valid(): FieldStatus {
    return new FieldStatus(true, []);
  }

  static invalid(): FieldStatus {
    return new FieldStatus(false, []);
  }

  static buildFrom(errors: TranslationKey[]): FieldStatus {
    return new FieldStatus(errors.length === 0, errors);
  }

  addErrorCode(code: TranslationKey): void {
    this.errors.push(code);
    this.isValid = false;
  }

  get isEmpty(): boolean {
    return this.isValid === undefined;
  }
}
